import React, { PropsWithChildren } from 'react'
import { styled, Tooltip } from '@mui/material'
import { colorPalette } from '../../../style/colorPalette'

interface MultiLineTooltipProps extends PropsWithChildren {
  message: string // 改行文字で改行される可能性のあるテキスト
}
export const MultiLineTooltip = ({
  message,
  children,
}: MultiLineTooltipProps) => {
  // 改行文字で分割して、複数行のツールチップを作成
  const tooltipContent = message.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < message.split('\n').length - 1 && <br />}
    </React.Fragment>
  ))

  return (
    <StyledTooltip title={tooltipContent} placement="right" arrow={true}>
      {children}
    </StyledTooltip>
  )
}

const StyledTooltip = styled(({ className, ...props }: any) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  '& .MuiTooltip-tooltip': {
    backgroundColor: colorPalette.monotone[1],
    color: colorPalette.monotone[10],
    fontSize: '13px',
    lineHeight: '1.8',
    padding: '12px 16px',
    maxWidth: '400px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    borderRadius: '6px',
    fontWeight: 400,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  '& .MuiTooltip-arrow': {
    color: colorPalette.monotone[1],
  },
})
